import ClosedLoopSection from '../../../website-mobile/components/ClosedLoopSection/ClosedLoopSection';
import '../../../website-mobile/mobile-scope.css';
import styles from './page3.module.css'

export default function Page3({ handleBtnClick }) {
    return (
        <div className={`${styles.page3} website-mobile-scope`} data-nav-theme="dark">
            <ClosedLoopSection handleBtnClick={handleBtnClick} />
        </div>
    );
}